import { Stack, Group, Text, Grid, Card, Badge, Code } from '../../../../components/ui';
import { IconCheck, IconX, IconServer } from '@tabler/icons-react';
import type { RabbitMqOverviewTabProps } from '../types';

export function RabbitMqOverviewTab({ connectionStats, queueStats }: RabbitMqOverviewTabProps) {
  return (
    <Stack gap="md">
      {/* Connection Info */}
      <Card>
        <Stack gap="sm">
          <Group gap="sm">
            <IconServer size={20} />
            <Text size="md" fw={600}>
              Connection Status
            </Text>
          </Group>
          {connectionStats && (
            <Grid>
              <Grid.Col span={6}>
                <Text size="sm" c="dimmed">
                  Status
                </Text>
                <Badge
                  color={connectionStats.isConnected ? 'green' : 'red'}
                  leftSection={connectionStats.isConnected ? <IconCheck size={14} /> : <IconX size={14} />}
                >
                  {connectionStats.isConnected ? 'Connected' : 'Disconnected'}
                </Badge>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm" c="dimmed">
                  Host
                </Text>
                <Code>
                  {connectionStats.hostName}:{connectionStats.port}
                </Code>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm" c="dimmed">
                  Virtual Host
                </Text>
                <Code>{connectionStats.virtualHost}</Code>
              </Grid.Col>
            </Grid>
          )}
        </Stack>
      </Card>

      {/* Queue Summary */}
      {queueStats && (
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
            <Card variant="gradient" gradientVariant="primary" padding="md">
              <Stack gap="xs">
                <Text size="sm" c="white" style={{ opacity: 0.9 }}>
                  Total Queues
                </Text>
                <Text size="xl" fw={700} c="white">
                  {queueStats.totalQueues}
                </Text>
              </Stack>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
            <Card variant="gradient" gradientVariant="success" padding="md">
              <Stack gap="xs">
                <Text size="sm" c="white" style={{ opacity: 0.9 }}>
                  Available
                </Text>
                <Text size="xl" fw={700} c="white">
                  {queueStats.availableQueues}
                </Text>
              </Stack>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
            <Card variant="gradient" gradientVariant="info" padding="md">
              <Stack gap="xs">
                <Text size="sm" c="white" style={{ opacity: 0.9 }}>
                  Total Messages
                </Text>
                <Text size="xl" fw={700} c="white">
                  {queueStats.totalMessages}
                </Text>
              </Stack>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
            <Card variant="gradient" gradientVariant="secondary" padding="md">
              <Stack gap="xs">
                <Text size="sm" c="white" style={{ opacity: 0.9 }}>
                  Consumers
                </Text>
                <Text size="xl" fw={700} c="white">
                  {queueStats.totalConsumers}
                </Text>
              </Stack>
            </Card>
          </Grid.Col>
        </Grid>
      )}
    </Stack>
  );
}
